import { Link } from "react-router-dom";
import footerBg from "../assets/footerbg.png";

function Footer() {
  return (
    <footer
      className="relative text-white bg-fixed"
      style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/80"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">

        {/* LOGO / ABOUT */}
        <div>
          <h2 className="text-2xl font-bold">GATI @ CO.ADVOCATES</h2>
          <p className="mt-4 text-gray-300">
            Providing trusted legal services with professionalism and integrity.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="hover:text-blue-400 transition">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-blue-400 transition">
                About
              </Link>
            </li>
            <li>
              <Link to="/services" className="hover:text-blue-400 transition">
                Services
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-blue-400 transition">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/insights" className="hover:text-blue-400 transition">
                Insights
              </Link>
            </li>
            <li>
              <Link to="/Team" className="hover:text-blue-400 transition">
                Team
              </Link>
            </li>
          </ul>
        </div>

       {/* SERVICES */}
<div>
  <h3 className="text-lg font-semibold mb-4">Services</h3>

  <ul className="space-y-2 text-gray-300">

    <li>
      <Link
        to="/services/commercial"
        className="hover:text-blue-400 transition"
      >
        Corporate & Commercial Law
      </Link>
    </li>

    <li>
      <Link
        to="/services/probate"
        className="hover:text-blue-400 transition"
      >
        Family & Succession Law
      </Link>
    </li>

    <li>
      <Link
        to="/services/litigation"
        className="hover:text-blue-400 transition"
      >
        Litigation and Despute Resolution
      </Link>
    </li>

    <li>
      <Link
        to="/services/conveyancing"
        className="hover:text-blue-400 transition"
      >
        Conveyancing & Real Estate
      </Link>
    </li>

    <li>
      <Link
        to="/services/intellectual"
        className="hover:text-blue-400 transition"
      >
        General Legal Consultancy
      </Link>
    </li>

    <li>
      <Link
        to="/services/criminal"
        className="hover:text-blue-400 transition"
      >
        Criminal Defence
      </Link>
    </li>

  </ul>
</div>



        {/* CONTACT */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Contact</h3>
          <p className="text-gray-300">P.O. BOX 881-20100</p>
          <p className="text-gray-300">Nakuru, Kenya</p>
          <p className="text-gray-300 mt-2">+254710565929/+254710304880</p>
          <p className="text-gray-300 mt-2">gaticoadvocates@gmail.com</p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="relative z-10 border-t border-white/20 text-center py-4 text-sm text-gray-300">
        © {new Date().getFullYear()} Gati@Co.Advocates All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;